// extracted by mini-css-extract-plugin
module.exports = {"blockContainer":"_2u0z0zOFIVDNGVuMcNWjSF","grayBackground":"_20BB6Ch_6fhaM7XjpenIbd"};